import _ from 'lodash'
import {EventBus} from '../../utils/EventBus'

const MembershipDashboardMixin = {
  props: ['members'],
  computed: {
    membersWithNoPrimaryContact: function () {
      return this.members.filter((x) => x.has_primary_contact === 0)
    },
    membersWithNoManager: function () {
      return this.members.filter((x) => x.has_member_manager === 0)
    },
    membersNotCategorized: function () {
      return this.members.filter((x) => x.has_category === 0)
    },
    membersNotConnectedToQuickbooks: function () {
      return this.members.filter((x) => x.is_connected_to_intuit === 0)
    },
    membersNotConnectedToWordPress: function () {
      return this.members.filter((x) => x.is_connected_to_wordpress === 0)
    },
    membersWithNoLogo: function () {
      return this.members.filter((x) => x.is_logo_valid === 0)
    },
    membersWithNoWebsite: function () {
      return this.members.filter((x) => x.is_website_valid === 0)
    },
    membersWithInvalidWebsite: function () {
      return this.members.filter((x) => x.is_website_valid === -1)
    },
    membersWithNoLinkedIn: function () {
      return this.members.filter((x) => x.is_linkedin_valid === 0)
    },
    membersWithInvalidLinkedIn: function () {
      return this.members.filter((x) => x.is_linkedin_valid === -1)
    },
    membersWithNoTwitter: function () {
      return this.members.filter((x) => x.is_twitter_valid === 0)
    },
    membersWithInvalidTwitter: function () {
      return this.members.filter((x) => x.is_twitter_valid === -1)
    },
    membersWithRectangularLogo: function () {
      return this.members.filter((x) => x.is_logo_square === 0)
    },
    membersCount: function () {
      return this.members.length
    }
  },
  mounted () {
  },
  methods: {
    sendMembersToTable (selectedData) {
      //  Some data sets use 'ID' to refer to specific organizations, others use 'account ID'.
      //  First check if 'id' was present in the sent data, and filtered out undefined, which occurs if the key is not in the object.
      let selectedIDs = _.map(selectedData, 'account_id').filter((x) => x !== undefined)
      //  if selectedIDs is empty, try with 'account_id', again filtering out undefined.
      selectedIDs = selectedIDs.length > 0 ? selectedIDs : _.map(selectedData, 'account_id').filter((x) => x !== undefined)
      EventBus.$emit('members-selected', selectedIDs)
      document.getElementById('member-list').scrollIntoView()
    }
  }
}

export default MembershipDashboardMixin



// WEBPACK FOOTER //
// ./src/components/membership/MembershipDashboardMixin.js